import DialogFunctions from "../../../core/dialogFunctions";

class AddFulfillmentPlanDialogController extends DialogFunctions {
  constructor($mdDialog, chosenCity) {
    "ngInject";

    super($mdDialog);
    this.chosenCity = chosenCity;
  }

  $onInit() {
    this.model = {
      city: this.chosenCity,
    };
  }
}

export default AddFulfillmentPlanDialogController;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlans/addFulfillmentPlanDialog/addFulfillmentPlanDialog.controller.js